import { render, staticRenderFns } from "./General-list-type.vue?vue&type=template&id=0d031c77&"
import script from "./General-list-type.vue?vue&type=script&lang=js&"
export * from "./General-list-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports